import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { guidesRegistry } from '../../data/guides/guidesRegistry';
import './InstructionsTab.css';
const InstructionsTab = () => {
    const { t, i18n } = useTranslation();
    const lang = (i18n.language || 'en').split('-')[0];
    return (_jsxs("div", { className: "instructions-tab", children: [_jsx("p", { className: "instructions-tab-intro", children: t('detailTabs.instructionsIntro', 'All guides and instructions at a glance:') }), _jsx("div", { className: "instructions-tab-grid", children: guidesRegistry.map((guide) => (_jsxs(Link, { to: guide.route, className: "instructions-tab-card", children: [_jsx("span", { className: "instructions-tab-icon", children: guide.icon }), _jsx("span", { className: "instructions-tab-title", children: guide.title[lang] || guide.title['en'] })] }, guide.id))) })] }));
};
export default InstructionsTab;
